export { default } from '@/views/error'
